import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';

import { CropperSettings, ImageCropperComponent } from 'ngx-img-cropper';
interface IChangeLogoModalContext {
	question: string;
	title?: string;
}
@Component({
	selector: 'app-change-logo-modal',
	templateUrl: './change-logo-modal.component.html',
	styleUrls: [ './change-logo-modal.component.scss' ]
})
export class ChangeLogoModalComponent implements OnInit, OnDestroy {
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;

	lotForm: FormGroup;
	file;
	image;

	cropperSettings: CropperSettings;
	data = { image: 'assets/avatar/1.jpg' };
	constructor(
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<IChangeLogoModalContext, void, void>
	) {
		this.lotForm = fb.group({
			lotName: [ '' ],
			lotCategory: [ '' ],
			budget: [ '' ],
			description: [ '' ],
			output_result: [ '' ]
		});
		this.cropperSettings = new CropperSettings();
		this.cropperSettings.noFileInput = true;
		this.cropperSettings.width = 480;
		this.cropperSettings.height = 400;

		this.cropperSettings.croppedWidth = 240;
		this.cropperSettings.croppedHeight = 200;

		this.cropperSettings.canvasWidth = 340;
		this.cropperSettings.canvasHeight = 240;
	}
	isFieldValid(field: string) {
		return (
			(!this.lotForm.get(field).valid && this.lotForm.get(field).touched) ||
			(this.lotForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field
		};
	}
	uploadImage($event) {
		this.file = $event[0];
		const image: any = new Image();
		const file: File = $event[0];
		const myReader: FileReader = new FileReader();
		const that = this;
		myReader.onloadend = (loadEvent: any) => {
			// image.src = loadEvent.target.result;
			that.image = loadEvent.target.result;
		};
		myReader.readAsDataURL(file);
	}
	submit() {
		this.modal.approve(this.file);
	}
	close() {
		this.modal.deny(null);
	}
	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class ChangeLogoModal extends ComponentModalConfig<IChangeLogoModalContext, void, void> {
	constructor(title: string, question: string, size: ModalSize = ModalSize.Small) {
		super(ChangeLogoModalComponent, { title, question });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
